<div
  role="radiogroup"
  aria-label="Split type"
  class="inline-flex w-full rounded-md border border-grey-800 p-1 gap-1"
>
  @for (option of options; track option.value; let i = $index) {
  <button
    type="button"
    role="radio"
    [attr.aria-checked]="option.value === value()"
    [attr.tabindex]="option.value === value() ? 0 : -1"
    [disabled]="disabled()"
    (click)="select(option)"
    (keydown)="onKeydown($event, i)"
    class="flex-1 rounded px-3 py-2 text-sm font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:opacity-50"
    [class.border]="option.value === value()"
    [class.border-[#1a2b6d]]="option.value === value()"
    [class.text-[#1a2b6d]]="option.value === value()"
    [class.text-grey-500]="option.value !== value()"
  >
    {{ option.label }}
  </button>
  }
</div>
